import React from "react";
import videoSrc from "../../videos/wecast-intro.mp4";

const VideoIntro = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100vw",
      height: "100vh",
      backgroundColor: "#000",
      overflow: "hidden",
    }}
  >
    <video
      src={videoSrc}
      autoPlay={false} // No autoplay, para que muestre el play nativo
      muted={false}
      loop
      controls // Controles nativos con play button
      preload="auto"
      style={{
        width: "85vw",
        height: "85vh",
        objectFit: "cover",
        borderRadius: "20px", // Esquinas redondeadas (ajustá el px si querés más/menos)
      }}
    />
  </div>
);

export default VideoIntro;
